const Input = {
  required: (name) => `${name} est obligatoire`,
  phone:
    "le numéro de téléphone doit être accompagné de l'indicatif régional ex: +2250605430832",
  correct: "Remplir correctement, merci",
};

export default Input;
